"use strict";

exports.__esModule = true;
exports.SelectionContextFields = SelectionContextFields;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
var _ConfigurableLayout = require("../../ConfigurableLayout");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Fields for SelectionContextElement.
 */
function SelectionContextFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.ElementCanvasSizeControlGroup, {
    elementEditor: elementEditor,
    path: path,
    element: element
  }), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "SelectionContextFields.rowCount.label",
      defaultMessage: "Rows"
    }),
    helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "SelectionContextFields.rowCount.helperText",
      defaultMessage: "The number of horizontal rows."
    })
  }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
    labelRenderer: false,
    min: 3,
    max: 48,
    value: element.props.rowCount || 12,
    onChange: function onChange(value) {
      return elementEditor.setProp(path, "rowCount", value);
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "SelectionContextFields.columnCount.label",
      defaultMessage: "Columns"
    }),
    helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "SelectionContextFields.columnCount.helperText",
      defaultMessage: "The number of vertical columns"
    })
  }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
    labelRenderer: false,
    min: 3,
    max: 48,
    value: element.props.columnCount || 12,
    onChange: function onChange(value) {
      return elementEditor.setProp(path, "columnCount", value);
    }
  })));
}